import { Component, Input, OnInit } from '@angular/core';

import { Trend } from './trends/trend';
import { TrendsService } from './trends/trends.service';

@Component({
  selector: 'app-trends',
  templateUrl: './trends.component.html',
  styleUrls: ['./trends.component.css']
})
export class TrendsComponent implements OnInit {

  @Input() onShowPeriod;
  @Input() showRating;
  @Input() showBusinessAreas;
  @Input() onFlexGrid;
  @Input() onEdit;

  trends: Trend [];
  mockTrends: Trend [] = [];

  windowWith;
  cubeHalf: Boolean = false;

  constructor(
    private _trendsService: TrendsService) {}

  getTrends(): void {
    this._trendsService.getTrends().then(trends => this.trends = trends);
  }

  getMockTrends(): void {
    this._trendsService.getMockTrends().then(mockTrends => this.mockTrends = mockTrends);
  }

  onResize(event) {
    this.windowWith = event.target.innerWidth;
    this.cubeSizeCheck();
  }

  cubeSizeCheck() {
    if (this.windowWith > 768) {
      this.cubeHalf = false;
    } else {
      this.cubeHalf = true;
    }
  }

  ngOnInit(): void {
    this.getMockTrends();
    this.getTrends();
  }

}



// WEBPACK FOOTER //
// /Users/Myrberg/Documents/spring_repo1/spring-app/src/app/base/components/canvas/components/trends/trends.component.ts